import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'toggle-switch',
    templateUrl: './toggle-switch.component.html',
    styleUrls: ['./toggle-switch.component.scss'],
    standalone: false
})
export class ToggleSwitchComponent implements OnInit {
  @Input() label: string = "";
  @Input() isCheckedByDefault: boolean = true;
  @Output() toggleChange = new EventEmitter<boolean>();
  
  isChecked: boolean = true;

  constructor() {}

  ngOnInit(): void {
    this.isChecked = this.isCheckedByDefault;
  }
 
  onToggleChange() {
    this.isChecked = !this.isChecked;
    this.toggleChange.emit(this.isChecked);
  }
}
